import { Box, Grid } from "@material-ui/core";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import PoolSelector from "src/components/Selector/PoolSelector";
import AuthorizationWrapper from "src/components/Wrapper/AuthorizationWrapper";

export default function DetailMonitoringWrapper({
  navigation,
  selectLink,
  Component,
  isAuthorization = false,
  children,
}) {
  return (
    <>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <CommonBreadcrumb
          config={[{ text: "analytics" }, { text: navigation.text, link: navigation.link }, { text: navigation.name }]}
        />
        <PoolSelector rootUrl={selectLink} />
      </Box>
      <Grid container style={{ marginBottom: "1.5rem" }}>
        <Grid item md={8} sm={12} xs={12} color="textSecondary">
          {Component?.Description}
        </Grid>
      </Grid>
      {isAuthorization ? <AuthorizationWrapper>{children}</AuthorizationWrapper> : <>{children}</>}
    </>
  );
}
